import * as React from 'react';

import ActionLink from 'components/buttons/action-link/ActionLink';

import { __t, applyTranslations } from 'utils/language';

import './realm-outfit-wmc-link.scss';

applyTranslations(require('./realm-outfit-wmc-link.i18n.json'));

type Props = {
  outfitLink?: string,
  creatorOutfitsLink?: string | null
};

const RealmOutfitWMCLink = ({
  outfitLink,
  creatorOutfitsLink
}: Props) => (
  <div className="realm-outfit-wmc-link">
    {outfitLink && (
      <span>
        <ActionLink
          link={outfitLink}
        >
          {__t('realm_outfit_wmc_link.outfit_link_tile')}
        </ActionLink>
      </span>
    )}
    {creatorOutfitsLink && (
      <span>
        <ActionLink
          link={creatorOutfitsLink}
        >
          {__t('realm_outfit_wmc_link.all_outfits_link_tile')}
        </ActionLink>
      </span>
    )}
  </div>
);

export default RealmOutfitWMCLink;
